var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTalkToExpert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24355 13.6283C9.24355 15.4787 7.83886 16.9596 6.08152 16.9596C4.32485 16.9596 2.91951 15.4786 2.91951 13.6283C2.91951 11.7782 4.32471 10.2979 6.08152 10.2979C7.83901 10.2979 9.24355 11.7781 9.24355 13.6283ZM6.08152 24C4.55751 24 3.22301 23.867 2.28834 23.5182C1.82497 23.3452 1.50149 23.1341 1.29811 22.9001C1.10697 22.6804 1 22.4169 1 22.0646C1 21.7133 1.10716 21.4518 1.29855 21.2337C1.50256 21.0012 1.82718 20.7919 2.29203 20.6207C3.22944 20.2756 4.5646 20.1472 6.08152 20.1472C7.60593 20.1472 8.94041 20.2803 9.875 20.6291C10.3382 20.802 10.6617 21.0131 10.8651 21.247C11.0561 21.4668 11.163 21.7302 11.163 22.0826C11.163 22.4339 11.0559 22.6954 10.8645 22.9135C10.6605 23.146 10.3359 23.3553 9.87108 23.5266C8.93362 23.8716 7.59846 24 6.08152 24Z",
    stroke: "current",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.055 3.39244H15.7298M10.055 5.78488H12.325M12.8924 10.5698L10.6226 8.17733H8.92011C8.29327 8.17733 7.78516 7.64178 7.78516 6.9811V2.19622C7.78516 1.53557 8.29327 1 8.92011 1H16.8648C17.4916 1 17.9998 1.53557 17.9998 2.19622V6.9811C17.9998 7.64178 17.4916 8.17733 16.8648 8.17733H15.1624L12.8924 10.5698Z",
    stroke: "current",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkToExpert);
export default __webpack_public_path__ + "static/media/talkToExpert.a49426e1cc3cf0b94fb09e700cc42155.svg";
export { ForwardRef as ReactComponent };